'use strict';
angular.module('MCPreviewForManuscriptsModule', [])
    .controller('MCPreviewForManuscriptsCtrl', ['$scope', '$modalInstance', 'draft', 'trsHttpService','$sessionStorage',
        function ($scope, $modalInstance, draft, trsHttpService, $sessionStorage) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.fileUrl = ''; // 附件下载地址 
                $scope.status = {
                    showPic: false,
                    showYsb: false,
                    ShowWd: false
                };
                $scope.params = {
                    messageId: draft.thirdid,
                    tenantId: $sessionStorage.get('curUserInfo').TENANTID
                };
                $scope.data = {
                    logoUrl: '', // 附件得logo
                    detail: {}, // 详情数据
                };
            }

            $scope.getFileType = function(item) {
                $scope.fileUrl = `/yuegao/appendix/download?appendixId=${item.appendixid}`;
                var name = item.filename.toLowerCase();
                if (/\.(gif|jpg|jpeg|png)$/.test(name)) {
                    // return $scope.status.showPic = true;
                    return item.logoUrl = './images/mc_pic.png';
                }
                if (/\.(doc|docx|xls|xlsx)$/.test(name)) {
                    // return $scope.status.ShowWd = true;
                    return item.logoUrl = './images/mc_wd.png';
                }
                return item.logoUrl = './images/mc_ysb.png';
            };

            /**
             * [dealCookieToken description] 设置查询所需的cookie
             *
             * @return  {[type]}  [return description]
             */
            function dealCookieToken() {
                let ygUsertoken = `yg_userToken=${$sessionStorage.cookie.get('userToken').token}`;
                ygUsertoken += '; path=/';
                document.cookie = ygUsertoken;
                // document.cookie = `yg_userToken=${$sessionStorage.cookie.get('userToken').token}`;

            }

            /**
             * [initData description] 状态初始化
             * @return {[type]} [description]
             */
            function initData() {
                dealCookieToken();

                $scope.loadingPromise = trsHttpService.httpServer('/yuegao/message/queryDetail', $scope.params, 'get').then((data) => {
                    $scope.data.detail = data.datas;
                });
            }

            /**
                 * [cancel description] 取消
                 * @return {[type]} [description]
                 */
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };

            /**
                 * [confirm description] 确定
                 * @return {[type]} [description]
                 */
            $scope.confirm = function () {
                $modalInstance.close();
            };

            /**
             * [downFile description]
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.downFile = function(item) {
                var params = {
                    appendixId: item.appendixid
                };
                $scope.loadingPromise = trsHttpService.httpServer('/yuegao/appendix/download', params, 'get').then((data) => {
                    // $scope.data.detail = data.datas;
                });
            }
        }
    ]);
